import { Alert } from 'components/common';
import {
  Checkbox,
  FormGroup,
  FormSection,
  Range,
  Select
} from 'components/common/form';
import { SettingsPercentageSelector } from '.';
import { useReduxState } from 'hooks';

const SettingsCompletionEnable = ({ formState }) => {
  const { messages, serverConfig } = useReduxState();

  return (
    <FormSection>
      <Alert
        expand={true}
        title={messages.settingsCompletionInfoTitle}
        text={
          <div>
            <p>{messages.settingsCompletionInfo}</p>
            <p>{messages.settingsCompletionInfoNote}</p>
          </div>
        }
      />

      <Checkbox
        field="completionEnabled"
        id="completion-enabled"
        label={messages.settingsCompletionEnable}
        style={{ marginTop: 20 }}
      />

      {serverConfig.courseCompletionElectronicSignature?.isEnabled ? (
        <Checkbox
          field="completionElectronicSignature"
          id="completion-electronic-signature"
          label={messages.settingsCompletionRequireSignature}
          style={{ marginTop: 10 }}
        />
      ) : null}

      <Range
        disabled={!formState.values.completionEnabled}
        field="completionTasks"
        id="completion-tasks"
        label={messages.settingsCompletionTasks}
        max={100}
        min={0}
        stepValue={10}
        style={{ marginTop: 20, maxWidth: 320 }}
        valueUnit="%"
      />

      <SettingsPercentageSelector
        disabled={!formState.values.completionEnabled}
        field="completionReading"
        id="completion-reading"
        label={messages.settingsCompletionReading}
        style={{ marginTop: 10, maxWidth: 320 }}
        value={formState.values.completionReading}
      />

      <SettingsPercentageSelector
        disabled={!formState.values.completionEnabled}
        field="completionVideos"
        id="completion-videos"
        label={messages.settingsCompletionVideos}
        style={{ marginTop: 10, maxWidth: 320 }}
        value={formState.values.completionVideos}
      />

      <FormGroup
        label={messages.settingsCompletionMaxVideoSpeed}
        labelHelpText={messages.settingsCompletionMaxVideoSpeedInfo}
      >
        <Select
          disabled={
            !formState.values.completionEnabled ||
            formState.values.completionVideos === 0
          }
          field="completionVideoMaxPlaybackSpeed"
          id="completion-video-max-playback-speed"
          options={[
            {
              label: messages.settingsCompletionMaxVideoSpeedNoIncrease,
              value: 1
            },
            { label: '1.25x', value: 1.25 },
            { label: '1.5x', value: 1.5 },
            { label: '1.75x', value: 1.75 },
            { label: '2.0x', value: 2.0 },
            { label: '2.5x', value: 2.5 }
          ]}
          style={{ maxWidth: 200 }}
        />
      </FormGroup>

      <FormGroup label={messages.settingsCompletionRetries}>
        <Checkbox
          disabled={!formState.values.completionEnabled}
          field="completionAllowRetries"
          id="completion-allow-retries"
          label={messages.settingsCompletionAllowRetries}
        />
      </FormGroup>

      <FormGroup label={messages.tasksAnswers}>
        <Checkbox
          disabled={!formState.values.completionEnabled}
          field="completionAllowAnswersAfterFinishing"
          id="completion-allow-answers-after-finishing"
          label={messages.settingsCompletionAllowAnswersAfterFinishing}
          labelTooltip={
            messages.settingsCompletionAllowAnswersAfterFinishingInfo
          }
        />
      </FormGroup>

      <FormGroup label={messages.settingsCompletionAllowAutomaticCompletion}>
        <Checkbox
          disabled={!formState.values.completionEnabled}
          field="automaticCompletion"
          id="automatic-completion"
          label={messages.settingsCompletionAutomaticCompletion}
          labelHelpText={messages.settingsCompletionAutomaticCompletionInfo}
        />
      </FormGroup>
    </FormSection>
  );
};

export default SettingsCompletionEnable;
